module.exports = {
  1: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  5: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  30: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  31: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  40: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  41: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  56: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  97: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  137: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  8453: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  17000: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  42161: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  43113: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  43114: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  59140: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  59144: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  80001: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  84531: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  421613: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  11155111: '0xbbcec987E4C189FCbAB0a2534c77b3ba89229F11',
  245022926: '0x6d982E13e39991c7492b85bC052bfBFcFca9C376',
  245022934: '0x6D61CDE28EF2Df6AB4d728A6f283Ad09B8E5d7b0',
}
